import {useEffect,useState, useRef} from "react";
import dayjs from "dayjs";

import Box from "@mui/material/Box";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  DatePicker,
  PickersDay,
  DayCalendarSkeleton,
} from "@mui/x-date-pickers";

/* ===================== Custom Day with COUNT Badge ===================== */
function CustomDay(props) {
  const {
    day,
    outsideCurrentMonth,
    highlightedData = {},
    ...other
  } = props;

  const dateKey = day.format("YYYY-MM-DD");
  const count = highlightedData[dateKey];

  return (
    <Badge
      badgeContent={count}
      color="primary"
      overlap="circular"
      invisible={!count}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{
        "& .MuiBadge-badge": {
          fontSize: 10,
          height: 16,
          minWidth: 16,
          borderRadius: "50%",
        },
      }}
    >
      {/* Wrapper prevents clipping */}
      <Box
        sx={{
          width: 36,
          height: 36,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <PickersDay
          {...other}
          day={day}
          outsideCurrentMonth={outsideCurrentMonth}
          disableRipple
          disabled // view-only
          sx={{ width: 32, height: 32 }}
        />
      </Box>
    </Badge>
  );
}

/* ===================== Main Component ===================== */
export default function IconOnlyCalendarWithCountBadge({value = dayjs(), highlightedData, apiCall, open, setOpen, iconRef}) {

  const [loading, setLoading] = useState(false);


  /* ---------------- API Call (Month + Year) ---------------- */
  const fetchCalendarData = async (date) => {
    setLoading(true);

    await apiCall(date)

    setLoading(false);
  };

  const handleCalendarChange = (data) => {

    let date = dayjs(data).format("YYYY-MM-DD")
    fetchCalendarData(date);
  };

  /* ---------------- Initial Load ---------------- */
  useEffect(() => {
    apiCall(dayjs().format("YYYY-MM-DD"));
  }, []);


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box>
        {/* Calendar Icon */}
        {/* <IconButton ref={iconRef} onClick={() => setOpen(true)}>
          <CalendarMonthIcon />
        </IconButton> */}

        <DatePicker
          open={open}
          onClose={() => setOpen(false)}
          defaultValue={value}
        //   value={value}
          loading={loading}
          onChange={() => {}} // disable date select
          shouldDisableDate={() => true}
          onMonthChange={handleCalendarChange}
          onYearChange={handleCalendarChange}
          renderLoading={() => <DayCalendarSkeleton />}
          slots={{ day: CustomDay }}
          slotProps={{
            day: { highlightedData },
            textField: { sx: { display: "none" } },
            popper: {
              anchorEl: iconRef.current,
              placement: "bottom-start",
              modifiers: [
                { name: "flip", enabled: true },
                { name: "preventOverflow", enabled: true },
                {
                  name: "offset",
                  options: { offset: [0, 7] },
                },
              ],
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}
